//      
             
                     
                     
             
                     
           
              
                     
import removeDraggableFromList from '../remove-draggable-from-list';
import isHomeOf from '../droppable/is-home-of';
import { emptyGroups } from '../no-impact';
import { find } from '../../native-with-fallback';
import getDisplacementGroups from '../get-displacement-groups';

              
                                
                                          
                                  
                     
                           
                           
                 
                               
   

function getIndexOfLastItem(
  draggables                      ,
  options                           ,
)         {
  if (!draggables.length) {
    return 0;
  }

  const indexOfLastItem         =
    draggables[draggables.length - 1].descriptor.index;

  // When in a foreign list there will be an additional one item in the list
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

                     
                                          
                      
                           
                                  
   

function goAtEnd({
  insideDestination,
  inHomeList,
  displacedBy,
  destination,
}             )             {
  const newIndex         = getIndexOfLastItem(insideDestination, {
    inHomeList,
  });

  return {
    displaced: emptyGroups,
    displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex,
      },
    },
  };
}

export default function calculateReorderImpact({
  draggable,
  insideDestination,
  destination,
  viewport,
  displacedBy,
  last,
  index,
  forceShouldAnimate,
}      )             {
  const inHomeList          = isHomeOf(draggable, destination);

  // Go into last spot of list
  if (index == null) {
    return goAtEnd({
      insideDestination,
      inHomeList,
      displacedBy,
      destination,
    });
  }

  // this might be the dragging item
  const match                      = find(
    insideDestination,
    (item                    ) => item.descriptor.index === index,
  );

  if (!match) {
    return goAtEnd({
      insideDestination,
      inHomeList,
      displacedBy,
      destination,
    });
  }
  const withoutDragging                       = removeDraggableFromList(
    draggable,
    insideDestination,
  );

  const sliceFrom         = insideDestination.indexOf(match);
  const impacted                       = withoutDragging.slice(sliceFrom);

  const displaced                     = getDisplacementGroups({
    afterDragging: impacted,
    destination,
    displacedBy,
    last,
    viewport: viewport.frame,
    forceShouldAnimate,
  });

  return {
    displaced,
    displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/calculate-drag-impact/calculate-reorder-impact.js